// Estos indices se corresponden con los definidos en el server
export const ProductType = {
    BiologicalSterilizer: 0,
    Protein: 1,
    ChemicalWasher: 2,
    ChemicalSterilizer: 3,
    BiologicalDisinfection: 4,
}
